<div
  class="sticky-connect tw-invisible tw-fixed tw-bottom-[155px] tw-right-[20px] tw-z-[999998] tw-opacity-0"
>
  <div ngbDropdown placement="top-end" class="">
    <button
      type="button"
      class="tw-mt-2 tw-inline-block tw-rounded-full tw-bg-primary tw-p-0 tw-text-white"
      id="connectDropdown"
      ngbDropdownToggle
    >
      <p-icon name="help" [iconClass]="'tw-w-[46px] tw-h-[46px]'" />
    </button>

    <div ngbDropdownMenu aria-labelledby="connectDropdown">
      @for (item of ctaList; track item) {
        <button
          ngbDropdownItem
          class="tw-flex tw-items-center"
          type="button"
          (click)="item.onClick()"
        >
          @if (item.icon !== 'robot') {
            <p-icon [name]="item.icon" />
          } @else {
            <div class="tw-inline-flex tw-items-center">
              <svg
                class="tw-h-[1.5rem] tw-w-[1.5rem] tw-align-middle"
                fill="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  d="M12 2C11.4 2 11 2.4 11 3V4H7C5.3 4 4 5.3 4 7V9H2V15H4V17C4 18.7 5.3 20 7 20H17C18.7 20 20 18.7 20 17V15H22V9H20V7C20 5.3 18.7 4 17 4H13V3C13 2.4 12.6 2 12 2ZM7 6H17C17.6 6 18 6.4 18 7V17C18 17.6 17.6 18 17 18H7C6.4 18 6 17.6 6 17V7C6 6.4 6.4 6 7 6ZM8.5 9C7.7 9 7 9.7 7 10.5C7 11.3 7.7 12 8.5 12C9.3 12 10 11.3 10 10.5C10 9.7 9.3 9 8.5 9ZM15.5 9C14.7 9 14 9.7 14 10.5C14 11.3 14.7 12 15.5 12C16.3 12 17 11.3 17 10.5C17 9.7 16.3 9 15.5 9ZM8 14C7.4 14 7 14.4 7 15C7 15.6 7.4 16 8 16H16C16.6 16 17 15.6 17 15C17 14.4 16.6 14 16 14H8Z"
                />
              </svg>
            </div>
          }
          <span class="tw-ml-2">{{ item.name | translate: item.nameVariables }}</span>
        </button>
      }
    </div>
  </div>
</div>
